<template>
<div>
  <v-icon v-if="state === true || state === 'true' || state == 'yes'" color="green">mdi-check</v-icon>
  <v-icon v-else color="red">mdi-close</v-icon>
</div>
</template>

<script>
export default {
  props: ['state']
}
</script>

<style scoped>
</style>
